import type { RefType } from '../types';

const baseCopy = [
    {
        title: 'MEMBERSHIP',
        content: [
            {
                subtitle: 'What is the EcoCredits Rewards Program?',
                text: 'The EcoCredits Rewards loyalty program is a EcoCredits-based program through which our customers (like you!) earn EcoCredits on ecoflow.com (excludes, but is not limited to, other third parties or retailers like Amazon, eBay, Walmart, etc.) Your EcoCredits unlock member benefits and can be redeemed for rewards. Just another way for us to say thank you to our customers and show how much we appreciate your loyalty.',
            },
            {
                subtitle: 'Who is eligible to join the EcoCredits Rewards Program?',
                text: 'Anyone over 13 in the EU or over 14 in the US (or another age required by local law) can join the program.',
            },
            {
                subtitle: 'How do I join the EcoCredits Rewards Program?',
                text: 'If you already have an account on ecoflow.com, you are already enrolled. You can log in to your existing account.\nIf you do not have an account with ecoflow.com, register an EcoCredits account now. Here is the <a href="https://ca.ecoflow.com/pages/rewards-guide">step-by-step guide</a> if you don\'t know how.\nYou cannot earn EcoCredits if you are not registered.',
            },
            {
                subtitle: 'Does it cost anything to join?',
                text: 'Our rewards program is totally free and you can start earning EcoCredits right away.',
            },
            {
                subtitle: 'Do my rewards, benefits and EcoCredits have any cash value?',
                text: 'Rewards, benefits and EcoCredits earned through EcoCredits Rewards have no cash value, and cannot be transferred to someone else.',
            },
            {
                subtitle: 'I have two EcoFlow accounts, can I merge them into one?',
                text: 'No. EcoCredits accumulated on different accounts by different members may not be combined or aggregated to make purchases of products or for any other reason.',
            },
            {
                subtitle: 'Where can I find my redeemable EcoCredits?',
                text: 'Please refer to the step-by-step guide to check your EcoCredits balance.',
            },
        ],
    },
    {
        title: 'EARNING EcoCredits',
        content: [
            {
                subtitle: 'Where can I earn EcoCredits?',
                text: 'Members earn EcoCredits at ecoflow.com and on the EcoFlow app. Members must be logged in to their EcoFlow account at the time of purchase or during other rewardable actions.',
            },
            {
                subtitle: 'When will I receive my EcoCredits?',
                text: 'EcoCredits will generally be added to your account within 24 hours. For purchases on ecoflow.com, EcoCredits will wait in your account until your order has shipped. Pending EcoCredits cannot be redeemed.',
            },
            {
                subtitle: 'What do I do if I believe EcoCredits were not properly credited to my account?',
                text: 'If you have questions related to your membership account, please contact Customer Service at support@ecoflow.com.',
            },
            {
                subtitle: 'Can my EcoCredits expire?',
                text: 'Yes. Your accumulated EcoCredits earned before our program officially launched (11/04/2022) will expire one year later. EcoCredits earned after our Program launch date will expire one year after the date they are unlocked. Your expired EcoCredits would be deducted from your account.',
            },
            {
                subtitle: 'Can I still earn EcoCredits for previous transactions made before the EcoCredits rewards program launched?',
                text: 'Yes! Before our EcoCredits Rewards Program was officially launched on 11/04/2022, EcoCredits for orders previously made were added to your account as long as you were logged in to your EcoFlow account at the time of that purchase. The EcoCredits will expire one year later. However, you cannot be credited for purchases that occurred before you became an EcoCredits member.',
            },
            {
                subtitle: 'How do I earn EcoCredits?',
                text: 'You will receive EcoCredits:\n1. At the time of account registration. Registration can only be rewarded once.\n2. Upon completion of your profile. Only the initial completion of your profile, portrait, and address can receive EcoCredits. Repeated corrections are not eligible for EcoCredits.\n3. When your purchased qualifying products are sent out.\n4. Register your product at “My Device” for a warranty. EcoCredits will be issued every time you complete a registration. An incorrect SN code for registration will not be rewarded.',
            },
            {
                subtitle: 'Can tax or shipping fees be rewarded?',
                text: 'No.Calculation of EcoCredits excludes payment by the Member for shipping charges and all taxes, including without limitation, federal, state, and local taxes or use taxes.',
            },
            {
                subtitle: 'Can a discount or gift card be credited for EcoCredits?',
                text: 'EcoCredits will not be earned on any discounts or other credits offered in connection with a product or service.',
            },
            {
                subtitle: 'What happens to my EcoCredits if I return a product or an order is cancelled?',
                text: 'Any product that is returned or any order that is canceled will reverse or decrease the EcoCredits you received from that purchase. EcoCredits would be deducted for partial refunds caused by price adjustments.',
            },
        ],
    },
    {
        title: 'REDEEMING EcoCredits',
        content: [
            {
                subtitle: 'How do I redeem EcoCredits for products?',
                text: 'Once you have logged into your EcoCredits account, head to our "Redeem EcoCredits Rewards" section. Choose the product and click “REDEEM NOW”. Then fill in the shipping form and submit.',
            },
            {
                subtitle: 'How can I track my redeemed products?',
                text: '1. Check the order number of your redeemed products in the "My Rewards" section. Click the order number to go to "My Account" page and track your parcel delivery satus. \n2. You will receive the order confirmation email after redemption. Once the redeemed products ships out, you will receive the shipping notification email with the tracking number.\n3. Please head to <a href="https://ca.ecoflow.com/pages/track-order">https://ca.ecoflow.com/pages/track-order</a> and enter your order number or tracking number for more info.',
            },
            {
                subtitle: 'Do I need to pay shipping fees for redeemed products?',
                text: 'For the most part, we offer free shipping for redeemed products. You may need to pay shipping fees for specific products.',
            },
            {
                subtitle: 'Can I cancel, return or exchange redeemed products?',
                text: 'No. Please double-check before you confirm the redemption. If products arrive damaged, please contact Customer Service at <a href="mailto:support@ecoflow.com">support@ecoflow.com</a> within 7 days.',
            },
            {
                subtitle: 'Can redeemed products be shipped with products I purchased from EcoFlow?',
                text: 'No. Redeemed products will be shipped seperately.',
            },
            {
                subtitle: 'Can I choose the shipping date of redeemed products?',
                text: 'No. The reward will be shipped out once you confirm the redemption.',
            },
            {
                subtitle: "My question isn't here. Who can I contact?",
                text: 'Please email <a href="mailto:support@ecoflow.com">support@ecoflow.com</a> for customer service.',
            },
            {
                subtitle: 'I have questions about my gift card. Who can I contact?',
                text: 'Please consult our customer service about EcoFlow Gift Card terms of use. For other gift cards, please contact third-parties for help.',
            },
            {
                subtitle: 'Can I retrieve the used discount code or gift card?',
                text: 'No, any rewards used can not be retrieved or cancelled for a second use.',
            },
        ],
    },
    {
        title: 'PLUS MEMBERSHIP & Benefits',
        content: [
            {
                subtitle: 'Who is eligible to become a PLUS MEMBER, and what is the difference between a PLUS MEMBER and a MEMBER?',
                text: "EcoFlow created the EcoCredits rewards program to give back to every EcoFlow lover. We offer our members the ultimate benefits, excellent services, and the latest updates. Having reached 1 million members at the start of 2024, it's time to upgrade EcoCredits benefits to empower every one of the million more!\nIt's totally free, and when you have 6,000 EcoCredits in your account, congratulations—you can upgrade to a PLUS MEMBER right away. Feel free to enjoy all the benefits of being a MEMBER, as well as exclusive discounts and service benefits only for PLUS MEMBERS.\nAll-in-one reliable membership services are only for you—every one of the million. The upgraded premium PLUS benefits allow you to save more, rest assured more, and experience more in this flexible energy future!",
            },
            {
                subtitle: 'Can my PLUS MEMBER status expire?',
                text: 'Yes, the validity period is one year.\nYour PLUS MEMBER status will expire one year after you upgrade from MEMBER to PLUS MEMBER if your EcoCredits balance is less than 6,000. If you still have 6,000 or more EcoCredits in your account, congratulations—you can maintain your PLUS MEMBER status.',
            },
            {
                subtitle: 'Will my PLUS MEMBER status change if I use EcoCredits for cash deductions or redeem vouchers/gifts?',
                text: "No worries! Within the validity period, even if you use your EcoCredits for cash deductions or redeem them for vouchers/gifts, you will still keep your PLUS MEMBER status. Don't forget to complete more tasks and earn more EcoCredits to maintain your status.",
            },
            {
                subtitle: 'What special discounts do I get as a PLUS MEMBER?',
                text: 'As a PLUS MEMBER, you will receive various discount vouchers, including:\n- A Level-up voucher (1st upgrade only)\n- A Birthday voucher\n- A Monthly voucher pack (issued during EcoCredits Monthly Madness)\n- PLUS exclusive gifts (*Remark: Only for PLUS MEMBERS with accumulated purchases over $10000 and only once for the entire program.)',
            },
            {
                subtitle: 'What service benefits do I get as a PLUS MEMBER?',
                text: 'As a PLUS MEMBER, you can enjoy the following services during your membership period:\nFree Unconditional Return (1 Order): Enjoy one free return within one month of purchase.\n\n12% Discount on Out-of-Warranty Service Charges: Receive a special discount on service charges for out-of-warranty repairs. EcoFlow reserves the right to determine the scope of repairs based on the actual situation.\n\nExpress Replacement Service: If your product is irreparably broken, you can use this service. After sending in your broken product and providing the proof of shipment, we will immediately send you a new product without waiting for the broken one to be received.',
            },
            {
                subtitle: 'What other experiences can I expect?',
                text: 'You will have access to our "New Product Trial Event" during the release of new EcoFlow products. As a PLUS MEMBER, you can receive new products for free and enjoy exclusive early bird benefits (which are coming soon). Stay tuned for more upcoming benefits!',
            },
        ],
    },
];

const accountings: { key: string; ref: typeof baseCopy }[] = [
    {
        key: 'default',
        ref: baseCopy,
    },
];

const getCaCopy = (key: string) => {
    const [data] = accountings.filter((item) => item.key === key);
    const copies: RefType = data?.ref || baseCopy;
    // filter array with Added key
    return copies.map((item, ind) => ({ ...item, key: ind }));
};

export default getCaCopy;
